import { render } from "./Pays.vue?vue&type=template&id=42e0f000&scoped=true"
import script from "./Pays.vue?vue&type=script&lang=js"
export * from "./Pays.vue?vue&type=script&lang=js"

import "./Pays.vue?vue&type=style&index=0&id=42e0f000&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e0f000"]])

export default __exports__